import React, { PureComponent } from 'react';
import {
  compose,
  withProps,
  renderNothing,
  branch
} from 'recompose';
import { issuuList } from './PreviewData';
import { withCreatePreviewNodeOnMount } from './withCreatePreviewNode';
import { withTranslationProvider } from '../Common/Translations';

class Preview extends PureComponent {
  render() {
    const { issuuId, friendlyUrl, t } = this.props;
    return (<div>
      <iframe
      key={issuuId}
      className='w-100'
      style={{ height: '460px' }}
      src={`//e.issuu.com/embed.html?d=${issuuId}&u=photobookworldwide`}
      frameBorder='0'
      allowFullScreen></iframe>
      { friendlyUrl ? <a className='btn btn-primary' href={`${friendlyUrl}`}>{t('footer.categorypage_previewmodal_createnow', 'CREATE NOW')} </a> : null}
      </div>);
  }
}

const isProductDetailDefined = productDetail =>
  productDetail && productDetail.attributeValues && productDetail.attributeValues.theme;

export const withIssuuId = compose(
  withProps(({ productDetail, selectedType, issuuId = undefined, friendlyUrl = undefined }) => {
    if (isProductDetailDefined(productDetail)) {
      const strArr = productDetail.attributeValues.theme.split('-').map(s => s.trim());
      const issuu = strArr[0] ? issuuList[strArr[0]] : null;
      if (issuu && issuu[selectedType]) {
        return {
          issuuId: issuu[selectedType],
          friendlyUrl: productDetail.attributeValues.friendlyUrl
        };
      }
    }
    return { issuuId, friendlyUrl };
  }),
);

const dontPreview = ({ issuuId, isGalleryFound }) => {
  let notPreviewable = (!issuuId || !isGalleryFound);
  let previewButton = document.getElementById('pb-preview-node');

  if (previewButton) {
    previewButton.style.visibility = notPreviewable ? 'hidden' : 'visible';
  }
 
  return notPreviewable;
};

const enhance = compose(
  branch(
    dontPreview,
    renderNothing,
  ),
  withTranslationProvider,
  withCreatePreviewNodeOnMount
);

export default enhance(Preview);
export const undecorated = Preview;



// WEBPACK FOOTER //
// ./src/IssuuPreview/Preview.js